import React from "react";

const UsersStrongIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  viewBox: "0 0 17 16",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.61016 13.6001H9.38988C9.8286 13.6001 10.1738 13.2433 10.0864 12.8218C9.84508 11.6582 9.05677 9.6001 6.50003 9.6001C3.94329 9.6001 3.15501 11.6582 2.91365 12.8218C2.82622 13.2433 3.17144 13.6001 3.61016 13.6001Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.5 6.3999C7.60457 6.3999 8.5 5.50447 8.5 4.3999C8.5 3.29533 7.60457 2.3999 6.5 2.3999C5.39543 2.3999 4.5 3.29533 4.5 4.3999C4.5 5.50447 5.39543 6.3999 6.5 6.3999Z",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.5 6.3999C11.472 6.3999 12.5 5.50447 12.5 4.3999C12.5 3.29534 11.472 2.3999 10.5 2.3999",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.3 9.6001C12.8097 9.6001 13.828 11.2366 14.0776 12.4161C14.2124 13.053 13.7213 13.6001 13.0994 13.6001H12.4263",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(UsersStrongIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;